export default __webpack_public_path__ + "static/media/misc-closetA-1920w.fbf3cfab.webp";